import { render } from "./AppointmentRegionForm.vue?vue&type=template&id=1d1c58bf&scoped=true&ts=true"
import script from "./AppointmentRegionForm.ts?vue&type=script&lang=ts"
export * from "./AppointmentRegionForm.ts?vue&type=script&lang=ts"

import "./AppointmentRegionForm.scss?vue&type=style&index=0&id=1d1c58bf&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1c58bf"]])

export default __exports__